import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logo from '../../common/Logo/Logo';
// Styled components
import Fade from './styled/Fade';

class PageTransition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enter: false,
      leave: false,
      hide: true,
      animationStartTime: 0,
    };
    this.el = false;

    // Transition end parade
    this.endTransition = this.endTransition.bind(this);
  }

  componentDidMount() {
    if(this.el) {
      this.el.addEventListener('transitionend', this.endTransition);
      this.el.addEventListener('webkitTransitionEnd', this.endTransition);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('isloading: ', nextProps, nextState, this.state);
    if(nextProps.isLoading) {
      // A new page is loading... trigger the animation
      // console.log('trigger enter');
      this.setState({
        enter: true,
        hide: false,
        animationStartTime: new Date().getTime(),
      });
    } else if(this.state.enter && !nextProps.isLoading && !this.state.leave) {
      // if the enter has happend and the page is done loading (false)
      // Trigger the leave animation
      // Check if the enter has finished yet... before continuing with leave
      // console.log('trigger leave');
      // const animationEndTime = new Date().getTime();
      // const diff = animationEndTime - this.state.animationStartTime;
      // console.log('animationTime diff', diff);
      // const delayTime = nextProps.enterDuration - diff > 0 ? nextProps.enterDuration - diff : 0;
      // console.log(delayTime);
      //nextProps.onAnimationEnd();
      setTimeout(() => {
        // console.log('set new leave state: ', this.state, new Date().getTime() - animationEndTime);
        // check if the state is still not lef
        if(this.state.enter) {
          this.setState({
            enter: false,
            leave: true,
          });
        }
      }, nextProps.enterDuration + 350);
    }
  }

  componentDidCatch(error, info) {
    console.warn('Error in Pagetransition', error, info);
  }

  endTransition() {
    // Update the leave to false after it's done.
    // console.log('end transition', this.state, this.props);
    if(!this.state.enter && this.state.leave) {
      // console.log('Leave has ended.. trigger the leave of the page');
      this.setState({
        leave: false,
        hide: true,
      });
      this.props.onAnimationEnd(false);
    } else if(this.state.enter) {
      // console.log('enter has ended.. trigger the render of the page');
      this.props.onAnimationEnd(true);
      // this.setState({
      //   leave: true,
      //   enter: false,
      //   hide: true,
      // });
    }
  }

  render() {
    const { enterDuration, leaveDuration } = this.props;
    // console.log('Transition state: ',this.state);
    // /*<div className='page-transition-inner'>*/
      /*<svg x='0px' y='0px' width='707.418px' height='82.486px' viewBox='0 0 707.418 82.486' className='logo'>*/
        /*<path d='M293.805,1.046c2.379,5.507,2.379,9.082,2.379,12.955v54.193c0,3.872,0,7.447-2.379,12.953h18.165 c-2.535-5.506-2.384-9.081-2.384-12.953V14.001c0-3.873-0.151-7.448,2.384-12.955H293.805z M381.452,75.787h-15.483V6.704h13.252 c24.27,0,33.95,21.336,34.393,34.763C414.061,54.752,409.595,75.787,381.452,75.787 M384.133,1.046h-33.649 c2.383,5.507,2.087,9.087,2.087,12.969V68.33c0,5.969,0.146,7.457-2.384,12.969h32.01c26.805,0,46.458-19.687,46.156-40.577 C427.911,15.951,407.659,1.046,384.133,1.046 M574.796,1.046c2.533,5.507,2.384,9.082,2.384,12.955v54.193 c0,5.953,0.149,7.447-2.384,12.953h18.165c-2.53-5.506-2.379-7-2.379-12.953V40.649h28.137l1.937-5.657h-30.073V7.404h26.172 c3.273,0,4.763-0.146,14.293,3.425l-4.02-9.783H574.796z M499.835,75.787c-10.718,0.15-28.435-12.205-29.928-34.991 c-0.891-13.398,7.151-33.65,29.928-33.494c10.727,0,28.294,11.904,29.781,34.54C530.512,55.39,523.366,75.345,499.835,75.787 M499.835,0.749c-25.607,0-44.366,20.544-44.366,41.686c0,23.677,20.544,39.905,44.517,39.609 c25.613-0.448,44.371-20.549,44.371-41.691C544.357,16.083,523.663,0.749,499.835,0.749 M670.738,81.147 c-2.529-5.506-2.384-7-2.384-12.953V40.649h28.143l1.937-5.657h-30.079V7.404h24.767c3.278,0,4.768-0.146,14.298,3.425l-4.023-9.783 h-50.822c2.53,5.507,2.385,9.082,2.385,12.955v54.193c0,5.953,0.146,7.447-2.385,12.953H670.738z M138.824,0h-3.127l-29.184,69.239 c-2.379,5.657-3.425,7.298-6.995,12.06h8.338l25.228-60.259l10.294,23.881l-10.333-0.015v7.268l13.432-0.01l12.449,29.135h18.461 c-5.507-6.256-6.995-7.151-9.827-13.85l-6.518-15.294l24.688-0.016l2.768-7.233l-30.536,0.015L138.824,0z M31.27,75.787H15.786 V6.704h13.251c24.271,0,33.946,21.336,34.394,34.763C63.879,54.752,59.413,75.787,31.27,75.787 M33.951,1.046H0.302 c2.378,5.507,2.082,9.087,2.082,12.969V68.33c0,5.969,0.15,7.457-2.384,12.969h32.015c26.799,0,46.453-19.687,46.156-40.577 C77.724,15.951,57.477,1.046,33.951,1.046 M233.599,61.198L207.991,1.192h-18.462c5.507,6.251,6.845,7.146,9.676,13.85 l28.882,67.444h3.128l29.189-69.382c2.233-5.505,3.419-7.296,6.995-11.913h-8.338L233.599,61.198z' />*/
      /*</svg>*/
    /*</div>*/
    return (
      <Fade
        ref={(el) => this.el = el}
        enterDuration={enterDuration}
        leaveDuration={leaveDuration}
        enter={this.state.enter}
        leave={this.state.leave}
        hide={this.state.hide}
      >
        <div className='page-transition-inner'>
          <div className='dot' />
          <div className='dot' />
          <div className='dot' />
        </div>
      </Fade>
    );
  }
}

PageTransition.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  enterDuration: PropTypes.number,
  leaveDuration: PropTypes.number,
  onAnimationEnd: PropTypes.func,
};
PageTransition.defaultProps = {
  enterDuration: 750,
  leaveDuration: 750,
  onAnimationEnd: () => true,
};

export default PageTransition;
